import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { notificationText, translate } from '../../features/notifications/model';
import { formatNotificationTime } from '../../features/notifications/nativeModel';
export default function NotificationItem({ notification: item, locale, busy, onPress, onDelete }) {
  const { title, body } = notificationText(item, locale);
  return (
    <article className={`pp-notification-card${item.isRead ? '' : ' is-unread'}`}>
      <button
        data-notification-id={item.id}
        type="button"
        className="pp-notification-open"
        disabled={busy}
        onClick={onPress}
      >
        <strong>
          {!item.isRead && <i aria-label={translate(locale, 'notifications.filterUnread')} />}
          <span>{title}</span>
        </strong>
        <span className="pp-notification-preview">{body}</span>
        <time dateTime={item.createdAt}>{formatNotificationTime(item.createdAt, locale)}</time>
      </button>
      <button
        type="button"
        className="pp-notification-delete"
        disabled={busy}
        onClick={onDelete}
        aria-label={translate(locale, 'notifications.deleteAccessibility')}
      >
        <FiTrash2 size={16} />
      </button>
    </article>
  );
}
